import { SESSION_KEY_IS_LOGIN } from "AppConstants";

const LOGIN_PATH = "/login";

/**
 * Sends this tab to login when the user signs out in another one. `storage` fires only in the tabs
 * that did not make the change, and a full page load is needed because App.js reads auth at render.
 *
 * @since NEXT_VERSION
 */
export const startSessionSync = () => {
    window.addEventListener("storage", (event) => {
        if (event.key !== SESSION_KEY_IS_LOGIN || event.newValue === "true") return;
        // Already on login (a sign-in elsewhere clears the flag before setting it), so nothing to do.
        if (window.location.pathname === LOGIN_PATH) return;

        window.location.assign(LOGIN_PATH);
    });
}
